import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteData';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-20">
          <div className="lg:w-1/3">
            <Link to="/" className="inline-block font-heading text-xl font-semibold text-white mb-4 cursor-pointer">
              {siteInfo.name}
            </Link>
            <p className="text-sm text-background-400 leading-relaxed max-w-sm">
              {siteInfo.description}
            </p>
          </div>

          <div className="flex flex-wrap gap-10 lg:gap-16">
            <div>
              <h4 className="text-sm font-semibold text-white mb-4">分类导航</h4>
              <div className="flex flex-col gap-2">
                <Link to="/category/jichu-jiqiao" className="text-sm text-background-400 hover:text-white transition-colors cursor-pointer">基础技巧</Link>
                <Link to="/category/jinjie-bianshi" className="text-sm text-background-400 hover:text-white transition-colors cursor-pointer">进阶变式</Link>
                <Link to="/category/jiaodu-tiaozheng" className="text-sm text-background-400 hover:text-white transition-colors cursor-pointer">角度调整</Link>
                <Link to="/category/lishi-qiyuan" className="text-sm text-background-400 hover:text-white transition-colors cursor-pointer">历史起源</Link>
                <Link to="/category/jiankang-anquan" className="text-sm text-background-400 hover:text-white transition-colors cursor-pointer">健康安全</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">关于我们</h4>
              <div className="flex flex-col gap-2">
                <Link to="/about" className="text-sm text-background-400 hover:text-white transition-colors cursor-pointer">品牌介绍</Link>
                <a href={`mailto:${siteInfo.author}@position-guide.com`} className="text-sm text-background-400 hover:text-white transition-colors cursor-pointer">联系邮箱</a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">热门文章</h4>
              <div className="flex flex-col gap-2">
                <Link to="/article/chuangjiaoshi-tiwei-de-jiben-yaoling" className="text-sm text-background-400 hover:text-white transition-colors cursor-pointer">基本要领</Link>
                <Link to="/article/chuangjiaoshi-jingdian-bianshi-yi" className="text-sm text-background-400 hover:text-white transition-colors cursor-pointer">双腿抬高式</Link>
                <Link to="/article/jiaodu-tiaozheng-de-kexue-yuanli" className="text-sm text-background-400 hover:text-white transition-colors cursor-pointer">角度科学原理</Link>
                <Link to="/article/qinmi-guanxi-zhong-de-goutong-yishu" className="text-sm text-background-400 hover:text-white transition-colors cursor-pointer">沟通艺术</Link>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} {siteInfo.fullName}。本站内容仅供教育参考，不构成医疗建议。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-white transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-white transition-colors cursor-pointer" rel="nofollow">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}